import styled from 'styled-components';

export const NewMacroSC = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;